import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "containerIFrameWeet"
};
const _hoisted_2 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("iframe", {
    src: _ctx.urlPlayer,
    class: "iFrameFull",
    allow: "fullscreen *;autoplay *"
  }, null, 8, _hoisted_2)]);
}